module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('accordion-item', {
    attrs: {
      "show-open": ""
    }
  }, [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Assessments by Age")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__g-10"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Comparison of Quantum Assessments by Age")]), _vm._v(" "), _c('div', {
    staticClass: "p-discount-rate-comparison__chart-select"
  }, [_c('option-filters', {
    attrs: {
      "name": "ageGroupChartType"
    }
  }, [_c('li', {
    class: {
      'm-option-filters--active': _vm.ageGroupChartType === 'bar'
    },
    on: {
      "click": function($event) {
        return _vm.updateAgeGroupChartType('bar')
      }
    }
  }, [_vm._v("Bar Chart\n                    ")]), _vm._v(" "), _c('li', {
    class: {
      'm-option-filters--active': _vm.ageGroupChartType === 'line'
    },
    on: {
      "click": function($event) {
        return _vm.updateAgeGroupChartType('line')
      }
    }
  }, [_vm._v("Line Chart\n                    ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid"
  }, [_c('div', {
    staticClass: "flex-grid__g-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-8"
  }, [(_vm.ageGroupChartType === 'bar') ? _c('bar', {
    attrs: {
      "dataset": _vm.ageGroupBarDataset,
      "labels": _vm.ageGroupBarLabels,
      "legend": false
    }
  }) : _vm._e(), _vm._v(" "), (_vm.ageGroupChartType === 'line') ? _c('linegraph', {
    attrs: {
      "dataset": _vm.ageGroupLineDataset,
      "labels": _vm.ageGroupBarLabels,
      "legend": false
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-1"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "u-text-center"
  }, [_c('chart-legend', {
    attrs: {
      "columns": 2,
      "values": [
        _vm.chosenRates[0],
        _vm.chosenRates[1]
      ],
      "legendWidth": _vm.chartLegendWidthTwo,
      "marginBottom": "30"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__g-10"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Deceased's Age at Death")]), _vm._v(" "), _c('div', {
    staticClass: "p-discount-rate-comparison__chart-select"
  }, [_c('option-filters', {
    attrs: {
      "name": "rateGroupChartType"
    }
  }, [_c('li', {
    class: {
      'm-option-filters--active': _vm.rateGroupChartType === 'bar'
    },
    on: {
      "click": function($event) {
        return _vm.updateRateGroupChartType('bar')
      }
    }
  }, [_vm._v("Bar Chart\n                    ")]), _vm._v(" "), _c('li', {
    class: {
      'm-option-filters--active': _vm.rateGroupChartType === 'line'
    },
    on: {
      "click": function($event) {
        return _vm.updateRateGroupChartType('line')
      }
    }
  }, [_vm._v("Line Chart\n                    ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid"
  }, [_c('div', {
    staticClass: "flex-grid__g-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-8"
  }, [(_vm.rateGroupChartType === 'bar') ? _c('bar', {
    attrs: {
      "dataset": _vm.rateGroupBarDataset,
      "labels": _vm.chosenRates,
      "legend": false
    }
  }) : _vm._e(), _vm._v(" "), (_vm.rateGroupChartType === 'line') ? _c('linegraph', {
    attrs: {
      "dataset": _vm.rateGroupLineDataset,
      "labels": _vm.chosenRates,
      "legend": false
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-1"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "u-text-center"
  }, [_c('chart-legend', {
    attrs: {
      "columns": 3,
      "values": _vm.ageLabels,
      "legendWidth": _vm.chartLegendWidthThree,
      "marginBottom": "30"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "a-table--short-no-style"
  }, [_c('table', {
    staticClass: "a-table u-full-width"
  }, [_c('tr', [_c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_c('h2', [_vm._v("\n                        Deceased's Age at Death\n                    ")])]), _vm._v(" "), _vm._l((_vm.chosenRates), function(rate) {
    return _c('th', {
      attrs: {
        "rowspan": "2"
      }
    }, [_c('h2', [_vm._v("\n                        Discount Rate " + _vm._s(rate) + "\n                    ")])])
  }), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('h2', [_vm._v("Difference")])])], 2), _vm._v(" "), _c('tr', [_c('th', [_c('h2', [_vm._v("£")])]), _vm._v(" "), _c('th', [_c('h2', [_vm._v("%")])])]), _vm._v(" "), _vm._l((_vm.rateGroupBarDataset), function(row) {
    return _c('age-group-row', {
      attrs: {
        "row": row
      }
    })
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9dc0defc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/discount-rate-comparison/components/sections/AssessmentsByAge.vue
// module id = 1781
// module chunks = 0